const $ = window.jQuery

$(() => {

  $('.popup-trigger').magnificPopup({
    type:'inline',
    midClick: true,
    removalDelay: 300,
    mainClass: 'mfp-zoom-in'
  });

})
